import React, {useState} from "react";
import Select, {CSSObjectWithLabel} from "react-select";
import { NLRTM } from "../../constants/NauticalLocationConstants";
import { StylesConfig } from 'react-select';
import {IPortDropDownType} from "../../interfaces/INauticalLocation";

type PortSelectorProps = {
    callback: (selectedPort: string) => void
    portOptions?: IPortDropDownType[]
}

const customStyles: StylesConfig<any, false> = {
    menu: (base) => ({
        ...base,
        zIndex: 99999,
    } as CSSObjectWithLabel),
    // Add other style overrides here if needed
};

export const PortSelector: React.FC<PortSelectorProps> = ({callback, portOptions}) => {
    const [port, setPort] = useState({value: NLRTM, label: 'NLRTM'})
    const onPortChange = (e: {value: string, label:string}) => {
        setPort(e)
        callback(e.value)
    }

    return (
        <div>
            <Select
                options={portOptions}
                onChange={onPortChange}
                value={port}
                styles={customStyles}
            />
        </div>
    )
}
